
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

import { candidateColorScheme } from 'lib/settings/theme/colors/candidate';
import { ShowcasePageTemplate } from 'components/templates/jobs/showcase';
import { ThemeProvider } from 'components/atoms/themeProvider';

const Jobs: NextPage = () => {
  const router = useRouter();
  const techQuery = router.query.tech as string;
  const techName =
    techQuery &&
    techQuery
      .charAt(0)
      .toUpperCase()
      .concat(techQuery.replace('-', ' ').slice(1));

  const title = techQuery
    ? `Vagas ${techName} | +300 Vagas para DEVs`
    : 'Geekhunter: Recrute Talentos tech | Vagas para profissionais tech';

  const description = techQuery
    ? `Encontre Vagas de ${techName} para várias cidades e senioridades. Crie um perfil na plataforma GeekHunter. Ver vagas agora!`
    : 'GeekHunter é uma plataforma especialista no match de profissionais de tecnologia e empresas. Encontre vagas para profissionais tech. Veja!';

  const monolithLink =
    process.env.NEXT_PUBLIC_MONOLITH_PATH || 'https://geekhunter.com.br';

  return (
    <ThemeProvider colors={candidateColorScheme}>
      <NextSeo
        title={title}
        description={description}
        canonical={`${monolithLink}${router.pathname}${techQuery ? '-' : ''}${
          techQuery || ''
        }`}
      />
      <ShowcasePageTemplate />
    </ThemeProvider>
  );
};

export default Jobs;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/vagas/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  